import styled from 'styled-components';
import { typeScale, getColor, StyleVars } from 'core/utils';

const Divider = styled.hr`
	content: '';
	display: block;
	border: none;
	width: 100%;
	height: 1px;
	background: ${getColor("alto")};
	margin: ${typeScale(2)} 0;

	@media(max-width: ${StyleVars.screenSm}) {
		margin-top: ${typeScale(1)};
		margin-bottom: 0;
	}
`;

export default Divider;
